import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		// 大屏配置项
		setting: {
			//cityOperationId:'43b51ffb6b6d4ffeaa09ed3ca04315b2',
			totalOrder: 20 * 10000,    //累计运单：+20万
			totalMoney: 7720 * 10000, //累计金额：+7720万
			todayOrder: 200,           //今日运单量：+200
			todayMoney: 77200,         //今日金额：+77200
			totalRequirement: 200,     //总订单量：+200
			todayRequirement: 5,       //今日订单量：+5
			totalOrderNational: 1000 * 10000,//累计运单次数全国 +1000万
		},
		cityTempData: [],
		// 城市屏幕业务消息配置
		businessCountSetting: {
			isSetting: true,
			businessExceptionCount: 50, // 异常统计
			businessIntoCount: 200,      // 上车
			businessIntoCountToday: 20, // 上车今日
			businessLoadingCount: 20 * 10000,   //  装车
			businessLoadingCountToday: 200, // 装车今日
			businessLockCount: 0,      // 锁定
			businessReceivingOrdersCount: 100 * 10000,// 接单
			businessReceivingOrdersCountToday: 200,// 接单今日
			businessUnLoadingCount: 20 * 10000,// 卸货
			businessUnLoadingCountToday: 200,// 卸货今日
		},
		// 城市屏幕系统消息配置
		sysCountSetting: {
			isSetting: true,
			systemReleaseOrderCount: 200, // 发单
			systemReleaseOrderCountToday: 5, // 发单今日
			systemPauseOrderCount: 5,// 暂停
			systemPauseOrderCountToday: 0,// 暂停今日
			systemStopOrderCount: 195,// 结束
			systemStopOrderCountToday: 3,// 结束今日
			systemReconciledCount: 7712 * 10000,// 已对账
			systemReconciledCountToday: 77012,// 已对账今日
			systemPaidCount: 7702 * 10000,// 已支付
			systemPaidCountToday: 75022// 已支付今日
		},
		// 城市屏项目统计配置
		projectSetting: {
			isSetting: true,
			todaytotalTransportOrderCount: 200,
			loadingAvgWaitTime: 30,
			loadingAvgWaitCarCount: 5,
		},
		// 城市屏项目前五配置
		projectTopFiveSetting: {
			isSetting: true,
			todayTotalTransportOrderCount: [60, 40, 25, 18, 9],
			loadingAvgWaitTime: [36, 27, 13, 9, 3],
			loadingAvgWaitCarCount: [8, 5, 4, 4, 2]
		},
		// 城市屏车队前十五配置
		fleetTopSetting: {
			isSetting: true,
			//totalCount:[43,28,17,15,4]
		},
		orderCount: 0 // 今日运单数
	},
	mutations: {
		setOrderCount(state, newData) {
			state.orderCount = newData; // 修改数据的 mutation
		}
	},
	actions: {
		updateOrderCount({ commit }, newData) {
			commit('setOrderCount', newData); // 触发 mutation 来更新数据
		}
	},
	getters: {
		getOrderCount: state => state.orderCount // 获取数据的 getter
	}
})